<template>
  <p-modal :visible="!!application" class="edit-summary-modal">
    <template slot="title"> Edit application fields </template>
    <form class="edit-summary-modal-content">
      <p-text-field v-model="aiSummary" :multiline="true" label="Summary"></p-text-field>
      <p-multiselect v-model="detectability" label="Detectability" :searchable="false" :options="assessmentOptions" />
      <p-multiselect v-model="infringementLikelihood" label="Infringement Likelihood" :searchable="false" :options="assessmentOptions" />
      <p-multiselect v-model="internalProductCoverage" label="Internal Product Coverage" :searchable="false" :options="assessmentOptions" />
      <p-multiselect v-model="standardsLikelihood" label="Standards Likelihood" :searchable="false" :options="assessmentOptions" />

      <div class="products">
        <div v-for="(product, index) in products" :key="product.id">
          <div class="product-header">
            <span>{{ product.name || 'New Product' }}</span>
            <p-button variant="text" type="button" @click="products.splice(index, 1)">
              <p-icon name="close"></p-icon>
            </p-button>
          </div>
          <div class="product-fields">
            <p-text-field v-model="product.name" label="Name"></p-text-field>
            <p-text-field v-model="product.company" label="Company"></p-text-field>
            <p-text-field v-model="product.score" type="number" label="Score"></p-text-field>
            <p-text-field v-model="product.similarityAssessment" type="number" label="Similarity Assessment"></p-text-field>
            <p-text-field v-model="product.summary" label="Summary"></p-text-field>
            <p-text-field v-model="product.ultimateParentCompany" label="Ultimate Parent Company"></p-text-field>
            <p-text-field v-model="product.source" label="Source"></p-text-field>

            <div class="checkboxes">
              <p-checkbox v-model="product.isInternal" label="Internal"></p-checkbox>
              <p-checkbox v-model="product.isCompetitor" label="Competitor"></p-checkbox>
            </div>
          </div>
        </div>
        <p-button
          color="primary"
          variant="text"
          type="button"
          @click="
            products.push({
              name: '',
              company: '',
              score: 0,
              similarityAssessment: 0,
              summary: '',
              ultimateParentCompany: '',
              source: 0,
              isInternal: false,
              isCompetitor: false
            })
          "
        >
          Add Product
        </p-button>
      </div>
    </form>
    <template slot="footer">
      <p-button color="secondary" variant="text" @click="close">Close</p-button>
      <p-button color="primary" @click="editSummary">Edit fields</p-button>
    </template>
  </p-modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import Button from '@/components/common/Button';
import TextField from '@/components/common/TextField';
import Icon from '@/components/common/MdIcon';
import Checkbox from '@/components/common/Checkbox';
import PMultiselect from '@/components/common/Multiselect';

export default {
  components: {
    'p-modal': Modal,
    'p-button': Button,
    'p-text-field': TextField,
    'p-icon': Icon,
    'p-checkbox': Checkbox,
    'p-multiselect': PMultiselect
  },
  props: {
    application: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  data() {
    return {
      assessmentOptions: ['none', 'low', 'medium', 'high', 'max'],
      aiSummary: this.application ? this.application.aiSummary || '' : '',
      detectability: this.application?.detectability || 'none',
      infringementLikelihood: this.application?.infringementLikelihood || 'none',
      internalProductCoverage: this.application?.internalProductCoverage || 'none',
      standardsLikelihood: this.application?.standardsLikelihood || 'none',
      products: this.application && this.application.products ? this.application.products.map((p) => ({ ...p })) : []
    };
  },
  watch: {
    application(app) {
      this.aiSummary = app ? app.aiSummary || '' : '';
      this.detectability = app?.detectability || 'none';
      this.infringementLikelihood = app?.infringementLikelihood || 'none';
      this.internalProductCoverage = app?.internalProductCoverage || 'none';
      this.standardsLikelihood = app?.standardsLikelihood || 'none';
      this.products = app && app.products ? app.products.map((p) => ({ ...p })) : [];
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    editSummary() {
      if (!this.application || !this.application.id) {
        return;
      }
      this.$emit('submit', {
        aiSummary: this.aiSummary,
        detectability: this.detectability === 'none' ? null : this.detectability,
        infringementLikelihood: this.infringementLikelihood === 'none' ? null : this.infringementLikelihood,
        internalProductCoverage: this.internalProductCoverage === 'none' ? null : this.internalProductCoverage,
        standardsLikelihood: this.standardsLikelihood === 'none' ? null : this.standardsLikelihood,
        products: this.products.map((p) => ({
          name: p.name,
          company: p.company,
          score: p.score,
          similarityAssessment: p.similarityAssessment,
          summary: p.summary,
          ultimateParentCompany: p.ultimateParentCompany,
          source: p.source,
          isInternal: p.isInternal,
          isCompetitor: p.isCompetitor
        }))
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-summary-modal {
  .edit-summary-modal-content {
    padding: 2rem;
    .products {
      padding: 10px;
      .product-header {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
      }
      .product-fields {
        padding: 0 10px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 1rem;
        margin-bottom: 1rem;

        .checkboxes {
          display: flex;
          justify-content: space-between;
          max-width: 11rem;
          margin-top: 1rem;
        }
      }
    }
  }

  footer {
    > button {
      &:not(:last-child) {
        margin-right: 1rem;
      }
    }
  }
}
</style>
